<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 196.963"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M42.554 99.652c5.414,-25.464 7.418,-35.282 -1.271,-71.15 3.772,-8.066 14.642,38.136 8.128,72.916 -1.742,-0.527 -3.646,-0.898 -6.857,-1.766z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M78.558 153.572c3.72,31.054 -2.832,37.677 -12.188,38.802 0.055,-10.874 -0.565,-23.248 -1.861,-37.119 5.314,0.602 9.996,0.042 14.049,-1.683z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M64.509 155.255c1.296,13.871 1.916,26.245 1.861,37.119 -4.28,0.515 -9.146,-0.12 -13.884,-0.093 -1.128,-0.124 -2.287,-0.2 -3.465,-0.25 -5.111,-10.815 -7.375,-22.613 -6.789,-35.396 6.668,0.448 14.094,-0.013 22.277,-1.38z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M42.232 156.635c-0.586,12.783 1.678,24.581 6.789,35.396 -13.294,-0.566 -28.957,2.048 -29.278,-26.378 4.606,-3.506 11.685,-6.544 21.238,-9.113 0.414,0.035 0.831,0.067 1.251,0.095z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M40.981 156.538c-9.01,2.38 -16.143,5.371 -20.853,8.827 -0.13,0.096 -0.258,0.192 -0.385,0.288 -0.043,-3.802 0.189,-8.16 0.738,-13.156 0.144,-8.238 1.95,-16.354 4.924,-23.271 8.125,1.601 15.23,2.306 21.315,2.115 -2.603,8.751 -4.096,17.118 -4.479,25.102 -0.21,-0.022 -0.418,-0.046 -0.624,-0.071 -0.213,0.055 -0.425,0.11 -0.636,0.166z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M42.241 156.443c0.383,-7.984 1.876,-16.351 4.479,-25.102 5.83,-0.183 10.724,-1.19 14.68,-3.02 1.286,9.53 2.322,18.508 3.109,26.934 -0.616,0.103 -1.227,0.2 -1.835,0.293 -7.688,1.173 -14.652,1.512 -20.433,0.895z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M64.509 155.255c-0.787,-8.426 -1.823,-17.404 -3.109,-26.934 3.046,-1.409 5.536,-3.305 7.471,-5.69 4.239,6.266 7.314,14.496 8.746,24.018 0.366,2.433 0.679,4.738 0.941,6.923 -4.053,1.725 -8.735,2.285 -14.049,1.683z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M68.871 122.631c-7.052,8.689 -21.664,10.861 -43.465,6.593 4.967,-11.55 13.194,-19.755 22.39,-19.594 8.267,0.144 15.631,4.953 21.075,13.001z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M77.617 146.649c-3.273,-21.753 -15.118,-36.762 -29.821,-37.019 -14.704,-0.258 -26.93,20.872 -27.315,42.867 -5.014,45.647 16.439,38.074 32.005,39.784 15.824,-0.09 33.08,7.206 25.131,-45.632zm-6.46 -20.38c0.204,-30.544 -5.875,-64.47 -18.14,-98.011 -8.536,-29.897 -17.062,-32.767 -17.61,-7.07 -0.353,30.888 -1.349,66.315 -8.572,104.802"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
